export default __webpack_public_path__ + "static/media/slide3.6c67d462.svg";